var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinsSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#71b6f9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,27.706v2.919C0,33.038,5.879,35,13.125,35S26.25,33.038,26.25,30.625V27.706c-2.823,1.989-7.984,2.919-13.125,2.919S2.823,29.7,0,27.706ZM21.875,8.75C29.121,8.75,35,6.788,35,4.375S29.121,0,21.875,0,8.75,1.962,8.75,4.375,14.629,8.75,21.875,8.75ZM0,20.535v3.527c0,2.413,5.879,4.375,13.125,4.375S26.25,26.476,26.25,24.063V20.535c-2.823,2.324-7.991,3.527-13.125,3.527S2.823,22.859,0,20.535Zm28.437.752C32.354,20.528,35,19.12,35,17.5V14.581a16.787,16.787,0,0,1-6.563,2.358ZM13.125,10.938C5.879,10.938,0,13.385,0,16.406s5.879,5.469,13.125,5.469S26.25,19.428,26.25,16.406,20.371,10.938,13.125,10.938Zm14.991,3.849C32.218,14.048,35,12.6,35,10.938V8.019c-2.427,1.716-6.6,2.639-10.985,2.857A7.655,7.655,0,0,1,28.116,14.786Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsSolid);
export default __webpack_public_path__ + "static/media/coins-solid.b0da6419139055f9f2a8ad99b91c6af0.svg";
export { ForwardRef as ReactComponent };